module.exports = __webpack_public_path__ + "static/img/icon_first_cn.803b61f4.png";